import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BG6MEPCE.js";

// src/react/rich-text/primitive.tsx
import GithubSlugger from "github-slugger";

// src/react/rich-text/util/heading-id.ts
function extractTextFromNode(node) {
  var _a;
  let textContent = "";
  (_a = node == null ? void 0 : node.content) == null ? void 0 : _a.forEach((child) => {
    if (child.type === "text") {
      textContent += child.text;
    }
    if ("content" in child && child.content) {
      textContent += extractTextFromNode(child);
    }
  });
  return textContent;
}

// src/react/rich-text/primitive.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var isDev = process.env.NODE_ENV === "development";
var SUFFIX_CUSTOM_MARK = "_mark";
var RichText = (props) => {
  var _a;
  let value;
  const contentRaw = (_a = props.content) != null ? _a : props.children;
  if (contentRaw) {
    if (Array.isArray(contentRaw)) {
      value = contentRaw;
    } else if (typeof contentRaw === "object" && contentRaw && "content" in contentRaw && // @ts-ignore
    Array.isArray(contentRaw.content)) {
      value = contentRaw.content;
    }
  }
  const slugger = new GithubSlugger();
  return /* @__PURE__ */ jsx(Fragment, { children: value == null ? void 0 : value.map((node, index) => {
    return /* @__PURE__ */ jsx(
      Node,
      {
        node,
        components: props.components,
        blocks: props.blocks,
        slugger,
        disableDefaultComponents: props.disableDefaultComponents
      },
      index
    );
  }) });
};
var defaultHandlers = {
  a: (props) => {
    return /* @__PURE__ */ jsx("a", __spreadValues({}, props));
  },
  p: ({ children }) => /* @__PURE__ */ jsx("p", { children }),
  b: ({ children }) => /* @__PURE__ */ jsx("b", { children }),
  highlight: ({ children }) => /* @__PURE__ */ jsx("span", { children }),
  em: ({ children }) => /* @__PURE__ */ jsx("em", { children }),
  s: ({ children }) => /* @__PURE__ */ jsx("s", { children }),
  kbd: ({ children }) => /* @__PURE__ */ jsx("kbd", { children }),
  code: ({ children }) => /* @__PURE__ */ jsx("code", { children }),
  ol: (_a) => {
    var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
    return /* @__PURE__ */ jsx("ol", __spreadProps(__spreadValues({}, rest), { children }));
  },
  ul: (_c) => {
    var _d = _c, { children } = _d, rest = __objRest(_d, ["children"]);
    return /* @__PURE__ */ jsx("ul", __spreadProps(__spreadValues({}, rest), { children }));
  },
  li: (_e) => {
    var _f = _e, { children } = _f, rest = __objRest(_f, ["children"]);
    return /* @__PURE__ */ jsxs(
      "li",
      __spreadProps(__spreadValues({}, rest.isTaskListItem ? { style: { display: "flex", alignItems: "baseline" } } : void 0), {
        children: [
          rest.isTaskListItem ? /* @__PURE__ */ jsx("input", { type: "checkbox", defaultChecked: rest.checked }) : null,
          children
        ]
      })
    );
  },
  h1: (_g) => {
    var _h = _g, { children } = _h, props = __objRest(_h, ["children"]);
    return /* @__PURE__ */ jsx("h1", __spreadProps(__spreadValues({}, props), { children }));
  },
  h2: (_i) => {
    var _j = _i, { children } = _j, props = __objRest(_j, ["children"]);
    return /* @__PURE__ */ jsx("h2", __spreadProps(__spreadValues({}, props), { children }));
  },
  h3: (_k) => {
    var _l = _k, { children } = _l, props = __objRest(_l, ["children"]);
    return /* @__PURE__ */ jsx("h3", __spreadProps(__spreadValues({}, props), { children }));
  },
  h4: (_m) => {
    var _n = _m, { children } = _n, props = __objRest(_n, ["children"]);
    return /* @__PURE__ */ jsx("h4", __spreadProps(__spreadValues({}, props), { children }));
  },
  h5: (_o) => {
    var _p = _o, { children } = _p, props = __objRest(_p, ["children"]);
    return /* @__PURE__ */ jsx("h5", __spreadProps(__spreadValues({}, props), { children }));
  },
  h6: (_q) => {
    var _r = _q, { children } = _r, props = __objRest(_r, ["children"]);
    return /* @__PURE__ */ jsx("h6", __spreadProps(__spreadValues({}, props), { children }));
  },
  hr: () => /* @__PURE__ */ jsx("hr", {}),
  img: (_s) => {
    var _t = _s, { caption, alt } = _t, rest = __objRest(_t, ["caption", "alt"]);
    return /* @__PURE__ */ jsx(
      "img",
      __spreadValues(__spreadProps(__spreadValues({}, rest), {
        alt: alt != null ? alt : caption
      }), caption ? { ["data-caption"]: caption } : {})
    );
  },
  video: (_u) => {
    var _v = _u, { caption } = _v, rest = __objRest(_v, ["caption"]);
    return /* @__PURE__ */ jsx(
      "video",
      __spreadValues(__spreadValues({
        controls: true
      }, rest), caption ? { ["data-caption"]: caption } : {})
    );
  },
  blockquote: ({ children }) => /* @__PURE__ */ jsx("blockquote", { children }),
  pre: ({ children, language }) => /* @__PURE__ */ jsx("pre", { "data-language": language, className: `language-${language}`, children }),
  table: ({ children }) => /* @__PURE__ */ jsx("table", { children }),
  tr: ({ children }) => /* @__PURE__ */ jsx("tr", { children }),
  td: ({ children, colspan, rowspan }) => /* @__PURE__ */ jsx("td", { colSpan: colspan, rowSpan: rowspan, children }),
  th: ({ children, colspan, rowspan }) => /* @__PURE__ */ jsx("th", { colSpan: colspan, rowSpan: rowspan, children }),
  thead: ({ children }) => /* @__PURE__ */ jsx("thead", { children }),
  tbody: ({ children }) => /* @__PURE__ */ jsx("tbody", { children }),
  tfoot: ({ children }) => /* @__PURE__ */ jsx("tfoot", { children }),
  br: () => /* @__PURE__ */ jsx("br", {}),
  u: ({ children }) => /* @__PURE__ */ jsx("u", { children })
};
var Node = ({
  node,
  components,
  blocks,
  slugger,
  disableDefaultComponents
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F;
  const children = (_a = node.content) == null ? void 0 : _a.map((childNode, index) => {
    return /* @__PURE__ */ jsx(
      Node,
      {
        node: childNode,
        parent: node,
        components,
        blocks,
        slugger,
        disableDefaultComponents
      },
      index
    );
  });
  let Handler;
  let props;
  switch (node.type) {
    case "paragraph":
      Handler = (_b = components == null ? void 0 : components.p) != null ? _b : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.p;
      props = { children };
      break;
    case "text":
      const clonedMarks = [...(_c = node.marks) != null ? _c : []];
      Handler = ({ children: children2 }) => /* @__PURE__ */ jsx(
        Marks,
        {
          marks: clonedMarks,
          components,
          blocks,
          disableDefaultComponents,
          children: children2
        }
      );
      props = { children: node.text };
      break;
    case "bulletList":
    case "taskList":
      Handler = (_d = components == null ? void 0 : components.ul) != null ? _d : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.ul;
      props = {
        children,
        isTasksList: node.type === "taskList"
      };
      break;
    case "orderedList":
      Handler = (_e = components == null ? void 0 : components.ol) != null ? _e : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.ol;
      props = {
        children,
        start: (_g = (_f = node.attrs) == null ? void 0 : _f.start) != null ? _g : 1
      };
      break;
    case "listItem":
      Handler = (_h = components == null ? void 0 : components.li) != null ? _h : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.li;
      props = {
        children,
        isTaskListItem: false
      };
      break;
    case "taskItem":
      Handler = (_i = components == null ? void 0 : components.li) != null ? _i : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.li;
      props = {
        children,
        isTaskListItem: true,
        checked: (_k = (_j = node.attrs) == null ? void 0 : _j.checked) != null ? _k : false
      };
      break;
    case "heading":
      const handlerTag = `h${node.attrs.level}`;
      Handler = (_l = components == null ? void 0 : components[handlerTag]) != null ? _l : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers[handlerTag];
      const id = slugger.slug(extractTextFromNode(node));
      props = { children, id };
      break;
    case "horizontalRule":
      Handler = (_m = components == null ? void 0 : components.hr) != null ? _m : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.hr;
      break;
    case "hardBreak":
      Handler = (_n = components == null ? void 0 : components.br) != null ? _n : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.br;
      break;
    case "blockquote":
      Handler = (_o = components == null ? void 0 : components.blockquote) != null ? _o : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.blockquote;
      props = { children };
      break;
    case "codeBlock":
      Handler = (_p = components == null ? void 0 : components.pre) != null ? _p : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.pre;
      const code = (_r = (_q = node.content) == null ? void 0 : _q[0].text) != null ? _r : "";
      props = {
        children,
        language: (_t = (_s = node.attrs) == null ? void 0 : _s.language) != null ? _t : "text",
        code
      };
      break;
    case "table":
      Handler = (_u = components == null ? void 0 : components.table) != null ? _u : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.table;
      const overridenChildren = /* @__PURE__ */ jsx(
        Node,
        {
          node: { type: "tableBody", content: node.content },
          parent: node,
          components,
          blocks,
          slugger,
          disableDefaultComponents
        }
      );
      props = { children: overridenChildren };
      break;
    case "tableRow":
      Handler = (_v = components == null ? void 0 : components.tr) != null ? _v : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.tr;
      props = { children };
      break;
    case "tableCell":
      Handler = (_w = components == null ? void 0 : components.td) != null ? _w : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.td;
      props = {
        children,
        colspan: node.attrs.colspan,
        rowspan: node.attrs.rowspan,
        colwidth: (_x = node.attrs.colwidth) != null ? _x : void 0
      };
      break;
    case "tableHeader":
      Handler = (_y = components == null ? void 0 : components.th) != null ? _y : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.th;
      props = {
        children,
        colspan: node.attrs.colspan,
        rowspan: node.attrs.rowspan,
        colwidth: (_z = node.attrs.colwidth) != null ? _z : void 0
      };
      break;
    case "tableFooter":
      Handler = (_A = components == null ? void 0 : components.tfoot) != null ? _A : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.tfoot;
      props = { children };
      break;
    case "tableBody":
      Handler = (_B = components == null ? void 0 : components.tbody) != null ? _B : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.tbody;
      props = { children };
      break;
    case "image":
      Handler = (_C = components == null ? void 0 : components.img) != null ? _C : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.img;
      props = {
        src: node.attrs.src,
        width: node.attrs.width,
        height: node.attrs.height,
        alt: node.attrs.alt,
        caption: node.attrs.caption
      };
      break;
    case "video":
      Handler = (_D = components == null ? void 0 : components.video) != null ? _D : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.video;
      props = {
        children,
        src: node.attrs.src,
        width: node.attrs.width,
        height: node.attrs.height,
        caption: node.attrs.caption
      };
      break;
    case "basehub-block": {
      const block = blocks == null ? void 0 : blocks.find((block2) => {
        var _a2, _b2;
        const typename = block2 == null ? void 0 : block2.__typename;
        const keysLength = Object.keys(block2).length;
        const id2 = (_b2 = block2 == null ? void 0 : block2._id) != null ? _b2 : (_a2 = block2 == null ? void 0 : block2._sys) == null ? void 0 : _a2.id;
        if (typeof id2 !== "string" && (!typename || keysLength > 1)) {
          if (isDev) {
            console.warn(
              `BaseHub RichText Error: make sure you send through the _id and the __typename for all custom blocks.
Received ${JSON.stringify(
                block2,
                null,
                2
              )}.`
            );
          }
          return false;
        }
        return id2 === node.attrs.id;
      });
      if (!block) {
        break;
      }
      Handler = (_E = components == null ? void 0 : components[block == null ? void 0 : block.__typename]) != null ? _E : () => /* @__PURE__ */ jsx(Fragment, {});
      props = block;
      break;
    }
    default:
      Handler = (_F = components == null ? void 0 : components[node.type]) != null ? _F : () => /* @__PURE__ */ jsx(Fragment, {});
      props = __spreadProps(__spreadValues({}, node.attrs), { children });
      break;
  }
  if (!Handler) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  return /* @__PURE__ */ jsx(Handler, __spreadValues({}, props));
};
var Marks = ({
  marks,
  children,
  components,
  blocks,
  disableDefaultComponents
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  if (!marks)
    return /* @__PURE__ */ jsx(Fragment, { children });
  const marksClone = [...marks];
  const mark = marksClone.pop();
  if (!mark)
    return /* @__PURE__ */ jsx(Fragment, { children });
  let Handler;
  let props;
  switch (mark.type) {
    case "bold":
      Handler = (_a = components == null ? void 0 : components.b) != null ? _a : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.b;
      props = { children };
      break;
    case "highlight":
      Handler = (_b = components == null ? void 0 : components.highlight) != null ? _b : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.highlight;
      props = { children };
      break;
    case "italic":
      Handler = (_c = components == null ? void 0 : components.em) != null ? _c : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.em;
      props = { children };
      break;
    case "strike":
      Handler = (_d = components == null ? void 0 : components.s) != null ? _d : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.s;
      props = { children };
      break;
    case "kbd":
      Handler = (_e = components == null ? void 0 : components.kbd) != null ? _e : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.kbd;
      props = { children };
      break;
    case "code":
      Handler = (_f = components == null ? void 0 : components.code) != null ? _f : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.code;
      props = {
        children
      };
      break;
    case "underline":
      Handler = (_g = components == null ? void 0 : components.u) != null ? _g : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.u;
      props = { children };
      break;
    case "link": {
      if (mark.attrs.type === "internal") {
        const block = blocks == null ? void 0 : blocks.find((block2) => {
          var _a2, _b2;
          const typename = block2 == null ? void 0 : block2.__typename;
          const keysLength = Object.keys(block2).length;
          const id = (_b2 = block2 == null ? void 0 : block2._id) != null ? _b2 : (_a2 = block2 == null ? void 0 : block2._sys) == null ? void 0 : _a2.id;
          if (typeof id !== "string" && (!typename || keysLength > 1)) {
            if (isDev) {
              console.warn(
                `BaseHub RichText Error: make sure you send through the _id and the __typename for all custom blocks.
Received ${JSON.stringify(
                  block2,
                  null,
                  2
                )}.`
              );
            }
            return false;
          }
          return id === // @ts-ignore
          mark.attrs.targetId;
        });
        if (!block) {
          props = {
            children,
            href: "#",
            target: (_h = mark.attrs.target) != null ? _h : void 0,
            internal: void 0
          };
          break;
        }
        props = {
          children,
          href: "#",
          target: (_i = mark.attrs.target) != null ? _i : void 0,
          internal: block
        };
      } else {
        props = {
          children,
          href: mark.attrs.href,
          target: (_j = mark.attrs.target) != null ? _j : void 0,
          internal: void 0,
          rel: ((_k = mark.attrs.target) == null ? void 0 : _k.toLowerCase()) === "_blank" ? "noopener noreferrer" : void 0
        };
      }
      Handler = (_l = components == null ? void 0 : components.a) != null ? _l : disableDefaultComponents ? () => /* @__PURE__ */ jsx(Fragment, {}) : defaultHandlers.a;
      break;
    }
    case "basehub-inline-block": {
      const block = blocks == null ? void 0 : blocks.find((block2) => {
        var _a2, _b2;
        const typename = block2 == null ? void 0 : block2.__typename;
        const keysLength = Object.keys(block2).length;
        const id = (_b2 = block2 == null ? void 0 : block2._id) != null ? _b2 : (_a2 = block2 == null ? void 0 : block2._sys) == null ? void 0 : _a2.id;
        if (typeof id !== "string" && (!typename || keysLength > 1)) {
          if (isDev) {
            console.warn(
              `BaseHub RichText Error: make sure you send through the _id and the __typename for all custom blocks.
Received ${JSON.stringify(
                block2,
                null,
                2
              )}.`
            );
          }
          return false;
        }
        return id === mark.attrs.id;
      });
      if (!block) {
        break;
      }
      Handler = // @ts-ignore
      (_m = components == null ? void 0 : components[(block == null ? void 0 : block.__typename) + SUFFIX_CUSTOM_MARK]) != null ? _m : () => /* @__PURE__ */ jsx(Fragment, { children });
      props = __spreadProps(__spreadValues({}, block), { children });
      break;
    }
    default:
      Handler = (_n = components == null ? void 0 : components[mark.type]) != null ? _n : () => /* @__PURE__ */ jsx(Fragment, {});
      props = __spreadProps(__spreadValues({}, mark.attrs), { children });
      break;
  }
  if (!Handler) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  return /* @__PURE__ */ jsx(
    Marks,
    {
      marks: marksClone,
      components,
      blocks,
      disableDefaultComponents,
      children: /* @__PURE__ */ jsx(Handler, __spreadValues({}, props))
    }
  );
};
function createRichTextWithDefaultComponents(defaultComponents) {
  return (props) => {
    return /* @__PURE__ */ jsx(
      RichText,
      __spreadProps(__spreadValues({}, props), {
        components: __spreadValues(__spreadValues({}, defaultComponents), props.components)
      })
    );
  };
}
var TOC = (props) => {
  var _a;
  const slugger = new GithubSlugger();
  const value = (_a = props.content) != null ? _a : props.children;
  return /* @__PURE__ */ jsx(Fragment, { children: value == null ? void 0 : value.map((node, index) => {
    return /* @__PURE__ */ jsx(
      Node,
      {
        node,
        components: props.components,
        slugger,
        disableDefaultComponents: props.disableDefaultComponents
      },
      index
    );
  }) });
};
export {
  RichText,
  TOC,
  createRichTextWithDefaultComponents
};
